export default "__VITE_ASSET__$62m27DI__"